import { Singleton } from '@visiba/instantiation';
import { HttpService, VisibaApiPromise } from '@services/http.service';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_client_base';
import type { CaseOtherApiModel, PrioritizedClientCaseResultV2 } from './generated/models';

@Singleton()
export class CasesApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('cases');
	}

	public getPrioritized(): VisibaApiPromise<PrioritizedClientCaseResultV2> {
		return this.httpService.get(`${this.getBaseUri()}/v2/prioritized`);
	}

	public deleteNewIncoming(callticket: string): VisibaApiPromise<unknown> {
		return this.httpService.delete(`${this.getBaseUri()}/newIncoming/appointment/${callticket}`);
	}

	public get(from?: VisibaDate, to?: VisibaDate): VisibaApiPromise<CaseOtherApiModel[]> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			from: from?.format('YYYY-MM-DD') ?? null,
			to: to?.format('YYYY-MM-DD') ?? null,
		});

		return this.httpService.get(`${this.getBaseUri()}${parameterHandler.getString()}`);
	}
}
